import {Link, useNavigate} from "react-router-dom";
import React, {useState, useEffect} from "react";
import {useAuth} from "../../context/AuthContext";
import {authApi} from "../../api";
//import { Offcanvas } from "bootstrap";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";


export default function Login() {

    const { login } = useAuth(); // context'teki login fonksiyonu
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const location = useLocation();


    useEffect(() => {
        const msg = localStorage.getItem("logoutMessage");
        if (msg) {
            toast.error(msg, { toastId: "logout-toast" });
            localStorage.removeItem("logoutMessage");
        }
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await authApi.login({ email, password });



            const { user, accessToken, refreshToken, cartGuid } = res.data;

            login(user, accessToken, refreshToken, cartGuid);

            // ❌ SİLME — ARTIK SİLMEK YOK!
            // localStorage.removeItem("cart_guid");

            // 🔁 Login başarılı → doğru yere yönlendir
            // Login başarılı
            const fromCheckout = sessionStorage.getItem("fromCheckout");

            if (fromCheckout) {
                sessionStorage.removeItem("fromCheckout");

                // önce modalı kapat
                const offcanvasEl = document.getElementById("login");
                if (offcanvasEl) {
                    const instance = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
                    instance?.hide();
                }

                // 🛒 sepete merge işlemi zaten login'de yapılıyor
                setTimeout(() => {
                    navigate("/checkout"); // 🔥 checkout'a geri dön
                }, 300);
            } else {
                // normal login
                const offcanvasEl = document.getElementById("login");
                if (offcanvasEl) {
                    const instance = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
                    instance?.hide();
                }
                navigate("/");
            }


            // 🟢 MERGED CART GUID'i backend dönerse BUNU GÜNCELLE
            // if (cartGuid) {
            //     localStorage.setItem("cart_guid", cartGuid);
            // }


            //navigate("/");      // giriş sonrası yönlendirme
            // ✅ Offcanvas'ı kapat (CDN kullandığın için window.bootstrap üzerinden erişiyoruz)

            // kullanılıyoddu
            // const offcanvasEl = document.getElementById("login");
            // if (offcanvasEl && window.bootstrap?.Offcanvas) {
            //     const instance = window.bootstrap.Offcanvas.getInstance(offcanvasEl) || new window.bootstrap.Offcanvas(offcanvasEl);
            //     instance.hide(); // ✅ animasyonlu kapanır
            // }


            // ❗ İsteğe bağlı yönlendirme (popup kapandıktan sonra yönlendir):
            // setTimeout(() => navigate("/"), 300);

        } catch (err) {
            setError("Login failed. Please check your credentials.");
            console.error("Login error:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="offcanvas offcanvas-end popup-style-1 popup-login input-page"
            id="login"
            data-bs-focus="false"
            // data-bs-backdrop="false"
        >
            <div className="canvas-wrapper">
                <div className="canvas-header popup-header">
                    <span className="title">Log in</span>
                    <button
                        className="icon-close icon-close-popup"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div>
                <div className="canvas-body popup-inner">
                    {/*<form*/}
                    {/*    action="account-page.html"*/}
                    {/*    acceptCharset="utf-8"*/}
                    {/*    className="form-login"*/}
                    {/*>*/}
                    {/*    <div>*/}
                    {/*        <fieldset className="email mb_12">*/}
                    {/*            <input type="email" className="" placeholder="Email*" />*/}
                    {/*        </fieldset>*/}
                    {/*        <fieldset className="password">*/}
                    {/*            <input type="password" className="" placeholder="Password*" />*/}
                    {/*        </fieldset>*/}
                    {/*    </div>*/}
                    {/*    <div className="bot">*/}
                    {/*        <a*/}
                    {/*            href="#resetPass"*/}
                    {/*            data-bs-toggle="offcanvas"*/}
                    {/*            className="text text-sm text-main-2"*/}
                    {/*        >*/}
                    {/*            Forgot your password?*/}
                    {/*        </a>*/}
                    {/*        <div className="button-wrap">*/}
                    {/*            <button*/}
                    {/*                className="subscribe-button tf-btn animate-btn d-inline-flex bg-dark-2 w-100"*/}
                    {/*                type="submit"*/}
                    {/*            >*/}
                    {/*                Sign in*/}
                    {/*            </button>*/}
                    {/*            <button*/}
                    {/*                type="button"*/}
                    {/*                data-bs-target="#register"*/}
                    {/*                data-bs-toggle="offcanvas"*/}
                    {/*                className="tf-btn btn-out-line-dark2 w-100"*/}
                    {/*            >*/}
                    {/*                Create an account*/}
                    {/*            </button>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</form>*/}
                    <form onSubmit={handleSubmit} className="form-login ">
                        <fieldset className="email mb_12">
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email*"
                                required
                            />
                        </fieldset>
                        <fieldset className="password">
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password*"
                                required
                            />
                        </fieldset>

                        {error && <p className="text-danger">{error}</p>}

                        <div className="bot">
                            <a href="#resetPass" data-bs-toggle="offcanvas" className="text-sm text-main-2">
                                Forgot your password?
                            </a>
                            <div className="button-wrap mt-4">
                                <button
                                    className="subscribe-button tf-btn animate-btn d-inline-flex bg-dark-2 w-100"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? "Signing in..." : "Sign in"}
                                </button>

                                <button
                                    type="button"
                                    data-bs-target="#register"
                                    data-bs-toggle="offcanvas"
                                    className="tf-btn btn-out-line-dark2 w-100"
                                >
                                    Create an account
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
